import { CountryCode } from "@vygruppen/vy-train-map";
import constate from "constate";
import { useState } from "react";

export type Tab =
  | TrainTab
  | BusTab
  | InfrastructureEventTab
  | DecisionSupportTab
  | ReserveBusTab
  | BackupBusTab;

export type TrainTab = {
  type: "train";
  countryCode: CountryCode;
  trainNumber: string;
  trainDate: string;
  tabId: string;
};

export type BusTab = {
  type: "bus";
  busId: string;
  tabId: string | undefined;
};

export type ReserveBusTab = {
  type: "reservebus";
  reserveBusId: string;
  reserveTabId: string | undefined;
};

export type BackupBusTab = {
  type: "backupbus";
  backupBusId: string;
  backupTabId: string | undefined;
};

// TODO: Remove this once these tabs are no longer found in the wild
//       (They shouldn't live longer than the shift of whoever was at work
//        when this change was deployed; new tabs are DecisionSupportTabs)
export type InfrastructureEventTab = {
  type: "infrastructureEvent";
  incidentId: string;
  stretchName: string;
};

export type DecisionSupportTab = {
  type: "decision-support";
  uuid: string;
  stretchName: string;
};

function useTabs() {
  const [activeIdTabs, setActiveIdTabs] = useState<Tab[]>([]);

  return {
    activeIdTabs,
    setActiveIdTabs,
  };
}

const [TabsProvider, useTabsContext] = constate(useTabs);

export { TabsProvider, useTabsContext };
